import { Card, Spin } from "antd";
import React from "react";
import Chart from "react-apexcharts";

const ObjectChart = ({ objectData, objectId, loading }) => {
  const chartOptions = {
    chart: {
      type: "bar",
      height: "100%",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 8,
        borderRadiusApplication: "end",
        columnWidth: "60%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["transparent"],
    },
    xaxis: {
      categories: objectData ? objectData.tags : [],
      title: {
        text: "Step",
      },
      labels: {
        rotate: -45, // Prevent label overlapping
      },
    },
    yaxis: {
      title: {
        text: "Value",
      },
    },
    tooltip: {
      enabled: true,
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    colors: ["#8b5cf6"],
    noData: {
      text: objectId ? "No data available" : "Please select an object to analyze",
      align: "center",
      verticalAlign: "middle",
    },
  };

  const chartSeries = [
    {
      name: "Value",
      data: objectData ? objectData.objects_count : [],
    },
  ];

  if (loading) {
    return (
      <Card style={{ height: 360 }}>
        <Spin />
      </Card>
    );
  }

  return (
    <Card style={{ height: 360 }}>{objectData && <Chart options={chartOptions} series={chartSeries} type="bar" height={300} width="100%" />}</Card>
  );
};

export default ObjectChart;
